import PrivilegeEnum from "../enums/PrivilegeEnum";
import productDetailsView from "../views/productDetailsView";
import getComments from "../services/jsonPlaceHolderAPI";
import returnHome from "../helpers/returnHome";
import displayInfoContainer from "../components/infoContainer";
import returnErrorView from "../helpers/returnErrorView";
import NullProduct from "../entities/NullProduct";
import createRemoveProductButton from "../components/removeProductButton";
import createEditProductButton from "../components/editProductButton";
import returnCart from "../helpers/returnCart";
export function productDetailsViewLogic(store, mainContent) {
    var product = getProduct(store);
    viewRendering(product, mainContent);
    getProductComments(); //should bringh comments by ProductId from the API
    buyProductEvents(product, store);
    removeProductEvents(product.id, store);
    editProductEvents(product.id);
}
//get product
function getProduct(store) {
    var productID = window.location.href.split("?")[1].split("=")[1];
    var product = store.getProductById(productID);
    if (product instanceof NullProduct) {
        returnErrorView();
    }
    return product;
}
//view rendering
function viewRendering(product, mainContent) {
    mainContent.innerHTML = productDetailsView(product);
}
//get product comments
function getProductComments() {
    var productCommentsContainer = document.getElementById("product-comments-container");
    getComments(productCommentsContainer);
}
//buy button event
function buyProductEvents(product, store) {
    var buyButtons = document.getElementsByName("buy-button");
    buyButtons.forEach(function (buyButton) {
        buyButton.addEventListener("click", function () {
            if (product.stock == 0) {
                displayInfoContainer("No es posible adquirir éste producto - Stock insuficiente.");
            }
            else {
                store.cart.add(product);
                updateProductsQuantityInCart(store);
                returnCart();
            }
        });
        if (store.user.privilege == PrivilegeEnum.admin) {
            buyButton.after(createRemoveProductButton());
            buyButton.after(createEditProductButton());
        }
    });
}
export function updateProductsQuantityInCart(store) {
    var productQuantity = document.getElementById("cart-quantity");
    productQuantity.innerHTML = " &nbsp " + store.cart.showAll().length;
}
//remove button event
function removeProductEvents(productId, store) {
    var removeButtons = document.getElementsByName("remove-product-button");
    if (removeButtons) {
        removeButtons.forEach(function (button) {
            button.addEventListener("click", function () {
                displayInfoContainer("¿Está seguro que desea eliminar éste producto?.", true, removeItem);
            });
        });
    }
    //remove item from store and return home
    function removeItem() {
        store.removeProduct(productId);
        returnHome();
        displayInfoContainer("El producto ha sido eliminado correctamente.");
    }
}
function editProductEvents(productId) {
    var editButtons = document.getElementsByName("edit-product-button");
    if (editButtons) {
        editButtons.forEach(function (button) {
            button.addEventListener("click", function () {
                window.location.hash = "/editProduct?id=" + productId;
            });
        });
    }
}
